import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import I18n from "../../../../i18n/utils";
import "./DeliveryPartnersTable.scss";
import { Button, Card, Modal } from "reactstrap";
import DataTable from "react-data-table-component";
import IDeliveryPartnersTable from "../../../interfaces/IDeliveryPartnersTable";
import assess from "../../../assets/icons/assess.svg";
import BusinessUnitOverrides from "../BusinessUnitOverrides/BusinessUnitOverrides";
import DeliveryPartnersForm from "../DeliveryPartnerForm/DeliveryPartnersForm";
import DeliveryPartner from "../../../interfaces/DeliveryPartner";
import CommissionRateHistoryForm from "../CommissionRateHistoryForm/CommissionRateHistoryForm";
import {
  getAllDeliveryPartners,
  getBusinessUnitOverridesByDeliveryPartner,
} from "../../../utils/api/DeliveryPartnersApi";
import { fetchDeliveryPartners } from "../../../redux/features/deliveryPartnerSlice";
import BusinessUnitOverridesImportForm from "../BusinessUnitOverrides/BusinessUnitOverridesImportForm/BusinessUnitOverridesImportForm";

const DeliveryPartnersTable: React.FC<IDeliveryPartnersTable> = ({
  showUpdateModal,
  closeUpdateModal,
  deliveryPartners,
  displayUpdateModal,
}: IDeliveryPartnersTable): JSX.Element => {
  // @ts-ignore
  const [selectedCell, setSelectedCell] = useState<DeliveryPartner>({});
  const [displayCommissionRateModal, setDisplayCommissionRateModal] =
    useState<boolean>(false);
  const [displayImportModal, setDisplayImportModal] = useState<boolean>(false);
  // @ts-ignore
  const [deliveryPartnerForm, setDeliveryPartnerForm] =
    useState<DeliveryPartner>({});
  const [expandedRow, setExpandedRow] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {}, [selectedCell]);

  const openCommissionRateForm = () => {
    setDisplayCommissionRateModal(true);
  };

  const selectCellAndOpen = (cell: React.SetStateAction<{}>) => {
    setSelectedCell(cell);
    if (selectedCell.deliveryPartnerId) {
      setDeliveryPartnerForm(cell);
    }
    showUpdateModal(true);
  };

  const closeDeliveryPartnerModal = () => {
    setSelectedCell({});
    closeUpdateModal();
  };

  const closeCommissionRateModal = () => {
    setDisplayCommissionRateModal(false);
    resetFormModal();
    dispatch(fetchDeliveryPartners());
  };

  const showImportModal = () => {
    setDisplayImportModal(true);
  };

  const actions = (
    <>
      <Button
        className="add-modal-button"
        onClick={() => showUpdateModal(true)}
      >
        {I18n.t("APP_DELIVERY_PARTNERS_ADD_FORM_TITLE")}
      </Button>
      <Button className="add-override-modal-button" onClick={showImportModal}>
        {I18n.t("APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE")}
      </Button>
    </>
  );

  /*
   * Close import modal and reload new overrides if dropdown is open
   * @return {null}
   */
  const closeImportModal = () => {
    setDisplayImportModal(false);
    resetFormModal();
    if (expandedRow) {
      dispatch(getBusinessUnitOverridesByDeliveryPartner(expandedRow));
    }
  };

  const resetFormModal = () => {
    return { loading: false, error: false, message: null };
  };

  const columns = [
    {
      cell: (cell: React.SetStateAction<{}>) => (
        <img
          id="logoTooltip"
          src={assess}
          width="20"
          height="20"
          className="edit-icon"
          alt="CFA Logo"
          onClick={() => selectCellAndOpen(cell)}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: I18n.t("APP_DELIVERY_PARTNERS_UPDATE_FORM_PARTNER_ID_LABEL"),
      selector: "deliveryPartnerId",
      sortable: true,
    },
    {
      name: I18n.t("APP_DELIVERY_PARTNERS_UPDATE_FORM_VENDOR_NAME_LABEL"),
      selector: "deliveryPartnerName",
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: I18n.t("APP_DELIVERY_PARTNERS_UPDATE_FORM_GROSS_SALES_LABEL"),
      selector: "grossSalesTransactionCode",
      sortable: true,
    },
    {
      name: I18n.t("APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_CODE_LABEL"),
      selector: "commissionTransactionCode",
      sortable: true,
    },
    {
      name: I18n.t("APP_DELIVERY_PARTNERS_UPDATE_FORM_START_DAY_LABEL"),
      selector: "salesWeekStartDay",
      sortable: true,
    },
    {
      name: I18n.t("APP_DELIVERY_PARTNERS_UPDATE_FORM_END_DAY_LABEL"),
      selector: "salesWeekEndDay",
      sortable: true,
    },
    {
      name: I18n.t("APP_DELIVERY_PARTNERS_UPDATE_FORM_PAYMENT_DAY_LABEL"),
      selector: "paymentDayOfWeek",
      sortable: true,
    },
  ];

  return (
    <Card className="DeliveryPartnersTable">
      <DataTable
        title={I18n.t("APP_DELIVERY_PARTNERS_TABLE_TITLE")}
        actions={actions}
        keyField="deliveryPartnersId"
        defaultSortField="deliveryPartnerId"
        defaultSortAsc={true}
        columns={columns}
        data={deliveryPartners}
        pagination
        persistTableHead
        responsive
        expandableRows
        expandOnRowClicked
        expandableRowsComponent={<BusinessUnitOverrides />}
        expandableRowExpanded={({ deliveryPartnerId }) =>
          deliveryPartnerId === expandedRow ? true : false
        }
      />
      <Modal
        isOpen={displayUpdateModal}
        className="modal-dialog"
        modalClassName="add-partner-modal"
      >
        <DeliveryPartnersForm
          deliveryPartners={deliveryPartners}
          selectedPartner={selectedCell}
          setDeliveryPartnerForm={setDeliveryPartnerForm}
          openCommissionRateForm={openCommissionRateForm}
          closeDeliveryPartnerModal={closeDeliveryPartnerModal}
        />
      </Modal>
      <Modal
        isOpen={displayCommissionRateModal}
        className="modal-dialog"
        modalClassName="add-partner-modal"
      >
        <CommissionRateHistoryForm
          deliveryPartnerForm={deliveryPartnerForm}
          //@ts-ignore
          selectedCommission={
            selectedCell
              ? selectedCell.deliveryPartnerCommissionRateHistoryList
              : {}
          }
          // @ts-ignore
          commissions={selectedCell.deliveryPartnerCommissionRateHistoryList}
          close={closeCommissionRateModal}
        />
      </Modal>
      {/* Import Modal 1*/}
      <Modal
        isOpen={displayImportModal}
        className="modal-dialog"
        modalClassName="add-partner-modal"
      >
        <BusinessUnitOverridesImportForm close={closeImportModal} />
      </Modal>
    </Card>
  );
};

export default DeliveryPartnersTable;
